
    <!-- partial:../../partials/_navbar.html -->
    <!-- <nav class="navbar default-layout-navbar p-0 fixed-top d-flex flex-row" style="width: 260px;height: 140px;">
        <div class="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center"
            style="border-right: 1px solid #9c9fa6;border-bottom: 1px solid #9c9fa6;">
            <img src="../../assets/POA_IconLogo.png" style="height:130px; " />
            <img src="../../assets/POA_TextLogo.png" style="padding-top: 65px;" />
        </div>

    </nav> -->
    <!-- partial -->
    <div class="container-fluid page-body-wrapper" style="padding-left: 260px; top: 50px; position: absolute; z-index: -1;">
        <!-- partial:../../partials/_sidebar.html -->
        
        <!-- partial -->
        <div class="main-panel">
            <div class="content-wrapper" style="padding: .5rem .8rem .5rem 3rem;">
                <div class="page-header">
                    <h3 class="page-title text-primary">
                        
                        Import Part Master
                    </h3>
                   
                </div>

                <div class="row" >
                    

                    <div class="col-md-4 stretch-card grid-margin">
                        <div class="card">
                            <div class="card-body" style="border: 1px solid #9c9fa6;">
                                <div class="clearfix">
                                    <div class="text-center" style="padding-top:10px;">
                                        <div class="upload-btn-wrapper">
                                            <button class="btnUpload">Upload &nbsp; <img src="../../assets/UploadIcon.png"> </button>
                                            <input type="file" #file name="myfile" (change)="uploadFile(file.files)" id="myfile"  />
                                          </div>

                                        <!-- <input type="file" #file class="btn btn-gradient-danger btn-icon-text" id="myfile" title="njf" style="padding: 14px 0px;" (change)="uploadFile(file.files)"/> -->

                                       <br />
                                        <span style="font-size:14px;">.xlsx Files Only</span>
                                        <!-- <input type="file" id="fileupload" style="visibility:hidden;" /> -->
                                    </div>
                                    <div class="text-center">
                                       
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 stretch-card grid-margin">
                        <a href="../../assets/ImportablePartMaster.xlsx" target="_blank">
                        <button class="btnDownload" >Download</button>
                    </a>
                    </div>
                    <div class="col-md-5 stretch-card grid-margin">
                        <span [hidden]="isShownError" style="font-size:14px;color: red;">{{ErrorMsg}}</span>
                        <span [hidden]="isShownSuccess" style="font-size:14px;color: green;">{{SuccessMsg}}</span>
                        
                    </div>


                   
                </div>
               
            </div>

           


            <footer class="footer">
                <div class="d-sm-flex justify-content-center">
                    <span class="d-block d-sm-inline-block">
                        © 2020 All Rights Reserved
                        <a href="https://www.sysmedacmicrosoft.com/#!/" target="_blank" style="color:black;">
                            <img src="../../assets/Logo-V3.png" width="70" />
                        </a>
        
                    </span>
        
                </div>
            </footer>
            
        </div>
        
    </div>
    
    <ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">  
        <img src="../../assets/Preloader.gif">
        <!-- <p style="color: white">Please Wait. </p>   -->
        </ngx-spinner>    

